import { app } from "../../bootstrap/core";
import { accountTransferComponent } from "./components/accountTransfer/accountTransfer.component";
import { OrderService } from "./order.service";
import { overviewComponent } from "./overview.component";
import { OverviewService } from "./overview.service";
import { overviewState } from "./overview.state";
import "../../common/ui/modals/confirmation.tpl.html";
import "../../common/ui/modals/feedback.tpl.html";
import "./components/owner/overviewOwner";
import "./components/transferList/transferList";

app.config(overviewState);
app.component(overviewComponent.name, overviewComponent);
app.component(accountTransferComponent.name, accountTransferComponent);
app.service("overviewService", OverviewService);
app.service("orderService", OrderService);



// WEBPACK FOOTER //
// ./src/app/components/overview/overview.js